var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAutosuggestionIkon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68.706,
    height: 44.013,
    viewBox: "0 0 68.706 44.013",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Autosuggestion-ikon",
    transform: "translate(-1041.744 -1797.205)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "inspection-2618572",
    transform: "translate(1043.158 1811.053)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_86",
    "data-name": "Ellipse 86",
    cx: 12.798,
    cy: 12.797,
    rx: 12.798,
    ry: 12.797,
    transform: "translate(3.169 0)",
    fill: "none",
    stroke: "#1f7672",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8366",
    "data-name": "Path 8366",
    d: "M147.442,52.4a8.748,8.748,0,0,0-7.747,4.687m-.947,3.084a8.315,8.315,0,0,0-.049.959",
    transform: "translate(-131.476 -48.333)",
    fill: "none",
    stroke: "#1f7672",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_154",
    "data-name": "Line 154",
    x1: 6.909,
    y2: 6.909,
    transform: "translate(0 21.843)",
    fill: "none",
    stroke: "#1f7672",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1818",
    "data-name": "Group 1818",
    transform: "translate(1063.055 1798.205)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1815",
    "data-name": "Group 1815",
    transform: "translate(11.528)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_221",
    "data-name": "Ellipse 221",
    cx: 1.748,
    cy: 1.748,
    rx: 1.748,
    ry: 1.748,
    transform: "translate(6.002 12.623)",
    fill: "#1f7672",
    stroke: "#1f7672",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8914",
    "data-name": "Path 8914",
    d: "M1.748,0A1.748,1.748,0,1,1,0,1.748,1.748,1.748,0,0,1,1.748,0Z",
    transform: "translate(13.47 12.711)",
    fill: "#1f7672",
    stroke: "#1f7672",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_223",
    "data-name": "Ellipse 223",
    cx: 1.748,
    cy: 1.748,
    rx: 1.748,
    ry: 1.748,
    transform: "translate(20.956 12.817)",
    fill: "#1f7672",
    stroke: "#1f7672",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8661",
    "data-name": "Path 8661",
    d: "M301.663,67.9h16.065a8.736,8.736,0,0,1,8.739,8.739v9.727a8.736,8.736,0,0,1-8.739,8.739H303.711L297,100.278V95.105h-5.4",
    transform: "translate(-291.6 -67.9)",
    fill: "none",
    stroke: "#1f7672",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1816",
    "data-name": "Group 1816"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_223-2",
    "data-name": "Ellipse 223",
    cx: 1.748,
    cy: 1.748,
    rx: 1.748,
    ry: 1.748,
    transform: "translate(10.416 12.817)",
    fill: "#1f7672",
    stroke: "#1f7672",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8661-2",
    "data-name": "Path 8661",
    d: "M316.4,67.9H300.339a8.736,8.736,0,0,0-8.739,8.739",
    transform: "translate(-291.6 -67.9)",
    fill: "none",
    stroke: "#1f7672",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("line", {
    id: "Line_184",
    "data-name": "Line 184",
    x2: 24.829,
    transform: "translate(1074.311 1834.542)",
    fill: "none",
    stroke: "#1f7672",
    strokeLinecap: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_185",
    "data-name": "Line 185",
    x2: 13.302,
    transform: "translate(1074.311 1838.089)",
    fill: "none",
    stroke: "#1f7672",
    strokeLinecap: "round",
    strokeWidth: 2.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutosuggestionIkon);
export default __webpack_public_path__ + "static/media/Autosuggestion-ikon.5e674cb0fc4912254e158eb8ced5d483.svg";
export { ForwardRef as ReactComponent };